import React from "react";
import grass from "../../Asset/login/grass.png";
import { GrSubtract } from "react-icons/gr";
import { MdAdd } from "react-icons/md";
import cartModel from "../../model/cart.model";

const Items = ({ datalist, Getcart, setNewSummery,setCouponCode }) => {
  const UpdateData = async (item, quantity) => {
    const form = new FormData();
    form.append("quantity", quantity);
    form.append("product_id", item?.product_id?._id);
    form.append("cart_type", item?.cart_type);

    try {
      const response = await cartModel.Addcart(form);
      console.log("Update Response:", response);

      Getcart();
    } catch (error) {
      console.log("Update Error:", error);
    }
  };
  return (
    <div className="w-full">
      <div className="w-full grid grid-cols-1">
        <div className="w-full overflow-x-auto">
          <table className="w-full auto min-w-[500px]">
            <thead>
              <tr className="">
                <td className="text-textColor py-3 text-base font-semibold title1">Items ( {datalist?.length} item )</td>
                <td className="text-textColor py-3  text-base font-semibold">
                  <div className=" w-full flex items-center justify-center "> 
                    <span className="mr-16">Quantity</span>
                  </div></td>
                <td className="text-textColor py-3 text-base font-semibold">
                  <div className=" w-full flex items-center justify-end">
                     <span className="mr-6">Unit price</span></div></td>
              </tr>
            </thead>
            <tbody>
              {datalist?.map((item, index) => {
               
                return (
                  <tr key={index}>
                    <td>
                      <div className="flex gap-3 py-5">
                        <div className="w-16 h-16 border-1 rounded-lg border-textColor">
                          <img
                            src={item?.product_id?.profile_image?.location}
                            className="w-full object-cover h-full border rounded-lg"
                            alt="no"
                          />
                        </div>
                        <div className="flex flex-col">
                          <span className="text-base title1">{item?.product_id?.name}</span>
                          <span className="font-bold text-[19px] text-gray-400 title1">
                            {item?.product_id?.quantity}{" "}
                            {item?.product_id?.unit_type}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-4">
                    <div className=" w-full flex items-center justify-center"> 
                      <div className="flex gap-4 items-center">
                        <div
                          className="bg-textColor w-8 h-8 rounded-full text-white cursor-pointer flex items-center justify-center"
                          onClick={() => {
                            let a = item?.quantity - 1;
                            setCouponCode("")
                            setNewSummery("")
                            UpdateData(item, a);
                          }}
                        >
                          <GrSubtract className="text-[18px]"/>
                        </div>
                        <div className="bg-Background2 text-[14px] title1 w-12 h-12 rounded-full text-textColor font-bold cursor-pointer flex items-center justify-center">
                          {item?.quantity}
                        </div>
                        <div
                          className="bg-textColor title1 w-8 h-8 rounded-full text-white cursor-pointer flex items-center justify-center"
                          onClick={() => {
                            const total = item?.quantity + 1;
                            UpdateData(item, total);
                            setCouponCode("")
                            setNewSummery("")
                          }}
                        >
                          <MdAdd className="text-[22px]"/>
                        </div>
                      </div>
                      </div>
                    </td>
                    <td className="py-4 font-semibold">
                      <div className="w-full flex justify-end">
                     <span className="px-3 py-1 rounded-2xl title2 font-semibold bg-white">₹ {item?.product_id?.regular_price?.mrp_price} {item?.product_id?.regular_price?.mrp_price && "/ Unit"}</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Items;
